import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { morgansClient } from '../../../lib/connect/clients';
const coverageKey = (opportunityId)=>[
        'noticeSourceCoverage',
        opportunityId
    ];
/** Per-source coverage for a canonical Opportunity. Only state 'current' is complete (SAD-466). */ export function useNoticeSourceCoverage(opportunityId) {
    return useQuery({
        queryKey: coverageKey(opportunityId),
        queryFn: async ()=>(await morgansClient.listNoticeSourceCoverage({
                opportunityId
            })).coverage
    });
}
/** Record intel received outside any connector; refreshes coverage and publication history. */ export function useRecordManualIntel(opportunityId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input)=>morgansClient.recordManualIntel({
                opportunityId,
                ...input
            }),
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: coverageKey(opportunityId)
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'noticePublications'
                ]
            });
        }
    });
}
/** pending_review -> reviewed; the reviewer is the signed-in principal, server-side. */ export function useReviewNoticePublication(noticeId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (publicationId)=>morgansClient.reviewNoticePublication({
                publicationId
            }),
        onSettled: ()=>queryClient.invalidateQueries({
                queryKey: [
                    'noticePublications',
                    noticeId
                ]
            })
    });
}
